import { render, staticRenderFns } from "./DraftMessageList.vue?vue&type=template&id=0a7f2778&scoped=true&lang=pug"
import script from "./DraftMessageList.vue?vue&type=script&lang=ts"
export * from "./DraftMessageList.vue?vue&type=script&lang=ts"
import style0 from "./DraftMessageList.vue?vue&type=style&index=0&id=0a7f2778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f2778",
  null
  
)

export default component.exports